var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg153User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.186,326.083c-8.965-6.418-21.436-4.354-27.853,4.612l-98.4,137.447c-2.687,3.116-6.055,3.789-7.859,3.909 c-1.856,0.123-5.412-0.112-8.549-3.051l-63.595-62.061c-7.89-7.7-20.53-7.546-28.23,0.345c-7.7,7.891-7.545,20.529,0.345,28.23 l63.704,62.167c0.059,0.057,0.119,0.115,0.179,0.172c9.551,9.092,22.299,14.149,35.415,14.149c1.127,0,2.259-0.037,3.389-0.113 c14.288-0.952,27.626-7.9,36.596-19.063c0.232-0.289,0.455-0.583,0.671-0.884l98.8-138.006 C514.216,344.971,512.152,332.501,503.186,326.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.716,271.399c1.754,0.068,3.514,0.102,5.284,0.102c1.773,0,3.537-0.034,5.293-0.102 c51.318,1.233,100.594,20.362,139.276,54.179c8.302,7.257,20.913,6.41,28.169-1.891c7.257-8.301,6.41-20.912-1.891-28.169 c-26.353-23.039-56.863-40.309-89.595-51.086c33.064-24.782,54.496-64.277,54.496-108.683C391.749,60.897,330.853,0,255.999,0 s-135.75,60.897-135.75,135.75c0,44.423,21.448,83.93,54.534,108.711c-30.313,9.98-58.756,25.508-83.65,45.983 c-45.648,37.548-77.386,89.92-89.367,147.471c-3.755,18.033,0.744,36.555,12.34,50.815c11.54,14.191,28.651,22.329,46.947,22.329 h175.983c11.026,0,19.963-8.938,19.963-19.963s-8.939-19.963-19.963-19.963H61.052c-8.522,0-13.664-4.757-15.97-7.592 c-3.982-4.896-5.523-11.269-4.228-17.487C61.572,346.541,149.35,273.849,250.716,271.399z M160.177,135.751 c0-52.838,42.986-95.824,95.824-95.824s95.824,42.986,95.824,95.824c0,51.215-40.386,93.173-90.983,95.703 c-1.612-0.03-3.225-0.045-4.84-0.045c-1.609,0-3.217,0.016-4.823,0.046C200.572,228.933,160.177,186.971,160.177,135.751z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg153User);
export default __webpack_public_path__ + "static/media/153-user.2476e56c6fd928e48c4197d631a8f992.svg";
export { ForwardRef as ReactComponent };